import VNavigationDrawer from './VNavigationDrawer'

export default {
  VNavigationDrawer
}



// WEBPACK FOOTER //
// ./src/components/navigation-drawer/index.js